module.exports = __webpack_public_path__ + "static/img/img_5.0a37a15e.png";